/**
 * Helper for sending chat messages via WebSocket.
 */

import type { ChatMessageEntity } from '@saaga/shared/store/slices/chat-message-entity.interface'

import type { UseAgentsWebsocketConfigReturn } from '@/hooks/use-agents-websocket-config.hook'

interface SendViaWebSocketParams {
  content: string
  optimisticEntity: ChatMessageEntity
  conversationId: string | null
  agencySlug: string | null
  websocket: UseAgentsWebsocketConfigReturn
}

export const sendViaWebSocket = ({
  content,
  conversationId,
  agencySlug,
  websocket,
}: SendViaWebSocketParams): void => {
  if (!websocket.isConnected) return
  websocket.sendMessage(content, conversationId, agencySlug)
}
